module.exports = __webpack_public_path__ + "static/img/pop-light.a48796a9.png";